import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import ReactTooltip from 'react-tooltip'
import { AppWrapper, MotionWrapper } from '../../HOC'
import { urlFor, client} from '../../client'
import './skills.scss'

const Skills = () => {
  const [experiences, setExperiences] = useState([])
  const [skills, setSkills] = useState([])
  const [selectedCategory, setSelectedCategory] = useState('Backend');

  const filteredSkills = selectedCategory === 'All' ? skills : skills.filter(skill => skill.category === selectedCategory);

  experiences.sort((a, b) => b.works[0].order - a.works[0].order);
  filteredSkills.sort((a, b) => a.priority - b.priority);

  const categories = ['AWS', 'Backend', 'Frontend', 'DevOps', 'Security', 'Databases', 'Data Science'];

  useEffect(() => {
    const query = '*[_type == "experiences"]'
    const skillsQuery = '*[_type == "skills"]'

    client.fetch(query)
      .then((data) => {
        setExperiences(data);
      }) 

    client.fetch(skillsQuery)
      .then((data) => {
        setSkills(data);
      }) 
  }, [])

  return (
    <>
      <h2 className="head-text">Skills & Experience</h2>
      <div className="app__filter-buttons">
        {categories.map(category => (
          <button
            key={category}
            className={`app__filter-button ${selectedCategory === category ? 'selected' : ''}`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>
      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {filteredSkills.map((skill) => (
            <motion.div
              key={skill.name}
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
            >
              <div className="app__flex" style={{ backgroundColor: skill.bgColor }}>
                <img src={urlFor(skill.icon)} alt="skill-logo" style={{ cursor: 'pointer' }}/>
              </div>
              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div className="app__skills-experience">
            {experiences?.map((experience) => (
              <motion.div
                key={experience.year}
                className="app__skills-experience-item"
              >
                <div className="app__skills-experience-year">
                  <p className="bold-text">{experience.year}</p>
                </div>
                <motion.div className="app__skills-experience-works">
                  {experience?.works?.map((work) => (
                    <>
                      <motion.div 
                        key={work.name}
                        whileInView={{ opacity: [0, 1] }}
                        transition={{ duration: 0.5 }}
                        className="app__skills-experience-work"
                        data-tip
                        data-for={work.name}
                      >
                        <h4 className="bold-text">{work.name}</h4>
                        <p className="p-text">{work.company}</p>
                      </motion.div>
                      <ReactTooltip
                        id={work.name}
                        effect="solid"
                        arrowColor='#fff'
                        className="skills-tooltip"
                      >
                        {work.desc}
                      </ReactTooltip>
              </>
                  ))}
                </motion.div>
              </motion.div>
              
            ))}
        </motion.div>
      </div>
    </>
  )
}

export default AppWrapper(
  MotionWrapper(Skills, 'app__skills'), 
  'skills',
  'app__whitebg'
)